// TMOS Public Website Privacy Policy Page
// Date: January 27, 2025
// Purpose: Display privacy policy content

import React, { useEffect, useState } from 'react';
import { PublicHeader } from '@/components/public/PublicHeader';
import publicApi from '@/services/publicApi';

export const PrivacyPolicyPage: React.FC = () => {
    const [content, setContent] = useState<string>('');
    const [version, setVersion] = useState<string>('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadPrivacyPolicy();
    }, []);

    const loadPrivacyPolicy = async () => {
        try {
            const response = await publicApi.get('/public/privacy-policy');
            if (response.data.success && response.data.data) {
                setContent(response.data.data.content_html);
                setVersion(response.data.data.version);
            }
        } catch (error) {
            console.error('Error loading privacy policy:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <PublicHeader />

            <main className="flex-1">
                <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* Page Header */}
                    <div className="text-center mb-8">
                        <h1 className="text-4xl font-normal text-gray-900 mb-2">
                            Privacy Policy
                        </h1>
                        {version && (
                            <p className="text-sm text-gray-500">
                                Version {version}
                            </p>
                        )}
                    </div>

                    {loading ? (
                        <div className="flex justify-center items-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a5d2e]"></div>
                        </div>
                    ) : (
                        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
                            {content ? (
                                <div
                                    className="prose prose-lg max-w-none"
                                    dangerouslySetInnerHTML={{ __html: content }}
                                />
                            ) : (
                                <div className="text-center py-12">
                                    <p className="text-gray-500">Privacy policy content is being prepared. Please check back soon.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </main>

        </div>
    );
};

